module.exports = __webpack_public_path__ + "img/08.63e5fc9b.jpg";